export default class BlockImageGrid {
	constructor() {
		this.galleries = document.querySelectorAll('.block-image-grid');

		if (this.galleries.length > 0) {
			this.galleries.forEach((gallery) => {
				let masonryGrid = gallery.querySelector('.block-image-grid-masonry');
				if (masonryGrid) {
					if (typeof Masonry !== "function") {
						return;
					}
					new Masonry(masonryGrid, {
						percentPosition: true,
						transitionDuration: 0
					});
				}
			});
		}
	}
}
